'use strict'
import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Auth0Provider } from '@auth0/auth0-react'
import { I18nextProvider } from 'react-i18next'
import { SnackbarProvider } from 'notistack'
import i18n from './i18n'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const AUTH_DOMAIN = process.env.VITE_AUTH_DOMAIN ?? ''
const AUTH_CLIENT_ID = process.env.VITE_AUTH_CLIENT_ID ?? ''
const AUTH_AUDIENCE = process.env.VITE_AUTH_AUDIENCE ?? ''

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH_DOMAIN}
      clientId={AUTH_CLIENT_ID}
      audience={AUTH_AUDIENCE}
      redirectUri={window.location.origin}
      scope='profile email openid'
      useRefreshTokens={true}
      cacheLocation='localstorage'
    >
      <I18nextProvider i18n={i18n}>
        <SnackbarProvider maxSnack={3} autoHideDuration={4000}>
          <App />
        </SnackbarProvider>
      </I18nextProvider>
    </Auth0Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
